/**
 * Angular imports.
 */
import { Component, OnDestroy, OnInit } from '@angular/core';

/**
 * Service imports.
 */
import { DataStorageService } from '../../dataservices/data-storage.service';
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { GetService } from '../../dataservices/get.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';

/**
 * Library imports.
 */
import { OwlOptions } from 'ngx-owl-carousel-o';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Top Cases Component
 */
@Component({
  selector: 'app-top-cases',
  templateUrl: './top-cases.component.html',
  styleUrls: ['./top-cases.component.scss']
})
export class TopCasesComponent implements OnInit, OnDestroy {
  public casesOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    responsive: {
      0: {
        items: 2
      },
      400: {
        items: 2
      },
      600: {
        items: 3
      },
      940: {
        items: 2
      }
    },
    nav: true,
    margin: 14,
    // navigation: true,
    autoplay: false,
    autoWidth: false,
  };

  public suggestionData = [];

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances.
   */
  constructor(
    private jwtSer: JwtDecodeService,
    private getSer: GetService,
    public dss: DataStorageService,
    public mls: MultiLangService,
    public fcs: FunCollectionService) {
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    // this.getsuggestionList();
  }

  /**
   * get suggestion List
   */
  getsuggestionList(): void {
    this.subscriptions.add(this.getSer.getSuggestionList(1, 0, 0, this.dss.suggestion_keys.SUGGESTION_KEY_EXPLORE).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.suggestionData = data['data'].suggestion_list;
        } else {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
